import * as React from "react";

function Calendar(props) {
  return (
    <svg width={22} height={25} fill="none" {...props}>
      <rect
        x={1}
        y={3.236}
        width={20}
        height={20}
        rx={2}
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.445 1.014v4.444M6.555 1.014v4.444M1 10.014h20"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const CalendarIcon = React.memo(Calendar);
export default CalendarIcon;
